<card name="Store products table">
  <div card content>
    <smart-table [headers]="headers" [source]="source">
      <ng-template smartTableColumn="id" let-item>
        <td>
          <span class="font-weight-medium">{{ item.id }}</span> <br>
          <div class="d-inline-block"
               [popper]="popperDevice"
               popperApplyClass="popper-primary, popper-lg">
            <ng-container [ngTemplateOutlet]="deviceCode" [ngTemplateOutletContext]="{$implicit: false}"></ng-container>
          </div>

          <popper-content #popperDevice>
            <ng-container [ngTemplateOutlet]="deviceCode" [ngTemplateOutletContext]="{$implicit: true}"></ng-container>
          </popper-content>
        </td>

        <ng-template #deviceCode let-popper>
          <div class="d-flex align-items-center">
            <icon-apple [style.width.px]="10" class="mr-2 text-muted"></icon-apple>
            <span [class.pseudo-link]="!popper">
              {{ item.apple | reducer: popper ? item.apple.length : 20 }}
            </span>
          </div>

          <div class="d-flex align-items-center" [class.mt-n2]="!popper">
            <icon-android [style.width.px]="10" class="mr-2 text-muted"></icon-android>
            <span [class.pseudo-link]="!popper">
              {{ item.android | reducer: popper ? item.android.length : 20 }}
            </span>
          </div>
        </ng-template>
      </ng-template>

      <ng-template smartTableColumn="type" let-item>
        <td>
          {{ item.type }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="subject" let-item>
        <td>
          {{ item.subject }} <br>
          <small class="text-muted">{{ item.devMode }}</small>
        </td>
      </ng-template>

      <ng-template smartTableColumn="innerProduct" let-item>
        <td>
          <badge-exist existText="Inner product" existColor="success" [item]="item.innerProduct"></badge-exist>
        </td>
      </ng-template>

      <ng-template smartTableColumn="createdAt" let-item>
        <td>
          {{ item.createdAt | moment }}
        </td>
      </ng-template>
    </smart-table>
  </div>
</card>
